import { Injectable } from '@angular/core';

@Injectable()
export class UtilService {

  constructor() { }


  getIntValue(str: string): number {
    return Number(str.replace(/[^\d.]/g, ''));
  }


  padNumber(num: number, length: number, padChar: string): string {
    var s = num + "";
    while (s.length < length) s = padChar + s;
    return s;
  }
}



// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/shared/services/utilities/utils.service.ts